import { useEffect, useState } from "react";
import { searchUsers } from "../api/users";
import { searchFepks } from "../api/epks";

// Debounced combined search (users + EPKs). 2-char minimum, 300ms debounce.
// Borrows the cancelled-flag pattern from useUserSearch so stale responses
// are dropped. Clears the timeout on unmount.
export default function useSearch(query, delay = 300) {
  const [results, setResults] = useState([]);

  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) {
      setResults([]);
      return;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const [users, fepks] = await Promise.all([
          searchUsers(q),
          searchFepks(q),
        ]);
        if (!cancelled) {
          setResults([...(fepks || []), ...(users || [])]);
        }
      } catch (err) {
        console.error("Search failed:", err);
        if (!cancelled) setResults([]);
      }
    }, delay);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query, delay]);

  const clear = () => {
    setResults([]);
  };

  return { results, clear };
}
